import React, { useMemo } from 'react';
import { FilterSelect, FilterOption } from '@/components/ui';

export type InvestmentStrategyOption = { id: number; name: string; code: string };

interface Props {
    strategies: InvestmentStrategyOption[];
    value: number | '';
    onChange: (id: number | '') => void;
}

/**
 * Reusable investment strategy dropdown.
 * The parent is responsible for loading strategies and passing them in.
 */
const InvestmentStrategySelect: React.FC<Props> = ({ strategies, value, onChange }) => {
    const options: FilterOption[] = useMemo(
        () => strategies.map(s => ({ value: String(s.id), label: `${s.code} - ${s.name}` })),
        [strategies],
    );

    return (
        <FilterSelect
            label="Investment Strategy"
            options={options}
            value={options.find(o => o.value === String(value)) ?? null}
            onChange={opt => onChange(opt ? Number(opt.value) : '')}
        />
    );
};

export default InvestmentStrategySelect;
